import { render, staticRenderFns } from "./Accordian.vue?vue&type=template&id=6ccbc7e2&scoped=true"
import script from "./Accordian.vue?vue&type=script&lang=js"
export * from "./Accordian.vue?vue&type=script&lang=js"
import style0 from "./Accordian.vue?vue&type=style&index=0&id=6ccbc7e2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccbc7e2",
  null
  
)

export default component.exports